/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react';

export interface CurrencyOption {
  label: string;
  value: string;
}

export const useCurrencyOptions = () => {
  const [currencies, setCurrencies] = useState<CurrencyOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCurrencies = async () => {
      setLoading(true);
      try {
        const res = await fetch('https://openexchangerates.org/api/currencies.json');
        const data = await res.json();

        const options = Object.keys(data).map((code) => ({
          label: code,
          value: code,
        }));

        setCurrencies(options);
      } catch (error) {
        console.error('Failed to fetch currencies:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCurrencies();
  }, []);

  return { currencies, loading };
};
